import { ScreenerTopTradersParams } from "@api/token-screener/top-traders.ts";
import { useCallback, useState } from "react";
import {
  getDefaultTopTradersFilters,
  TopTradersFilterContext,
} from "@providers/top-traders-filter/context.ts";

const TopTradersFilterProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [filters, setFilters] = useState<ScreenerTopTradersParams["filters"]>(
    getDefaultTopTradersFilters(),
  );

  const onFiltersUpdate = useCallback(
    (filters: ScreenerTopTradersParams["filters"]) => {
      setFilters(filters);
    },
    [],
  );

  return (
    <TopTradersFilterContext.Provider
      value={{ filters, onFiltersUpdate: onFiltersUpdate }}
    >
      {children}
    </TopTradersFilterContext.Provider>
  );
};

export default TopTradersFilterProvider;
